import React, { PropsWithChildren } from 'react'
import Link from 'next/link'
import { useTheme } from 'styled-components'

import Text from '@components/atoms/Text'
import { TextVariants } from '@components/atoms/Text/Text'
import { Contract } from '@definitions/types/symfonyTypes'
import { RoutesSunpoint } from '@definitions/routes/RoutesSunpoint'
import { RoutesWellmaxx } from '@definitions/routes/RoutesWellmaxx'
import { PropsWithClassName } from '@helper/PropsWithClassName'
import { useStudioFinderActions } from '@states/providers/StudioFinderProvider'

import { getBirthdayErrorText } from '@components/molecules/Forms/FormUserData/utils/getBirthdayErrorText'

export function AgeValidationError({
  contract,
}: PropsWithChildren<PropsWithClassName & { contract: Contract }>): React.JSX.Element {
  const { setStep } = useStudioFinderActions()
  const theme = useTheme() as { key: string }
  const clubMitgliedWerdenHref =
    theme.key === 'sunpoint'
      ? RoutesSunpoint.SUNPOINT__CLUBMITGLIEDWERDEN
      : RoutesWellmaxx.WELLMAXX__CLUBMITGLIEDWERDEN

  return (
    <div>
      <Text className="my-0! font-medium!" variant={TextVariants.paragraph}>
        <span>{getBirthdayErrorText(contract)}</span>
        <Link
          onClick={() => setStep(2)}
          className="text-error!"
          href={clubMitgliedWerdenHref}
        >
          Hier
        </Link>
        <span> findest du unsere regulären Tarife. </span>
      </Text>
    </div>
  )
}
